export var PermitSource;
(function (PermitSource) {
    PermitSource[PermitSource["TokenlonAllowanceTarget"] = 0] = "TokenlonAllowanceTarget";
    PermitSource[PermitSource["Token"] = 1] = "Token";
    PermitSource[PermitSource["TokenPermit"] = 2] = "TokenPermit";
    PermitSource[PermitSource["Permit2AllowanceTransfer"] = 3] = "Permit2AllowanceTransfer";
    PermitSource[PermitSource["Permit2SignatureTransfer"] = 4] = "Permit2SignatureTransfer";
})(PermitSource || (PermitSource = {}));
//# sourceMappingURL=permit2.js.map